// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__38kgO","insightsList":"newBusinessInsightsMenu_insightsList__2dJc-","active":"newBusinessInsightsMenu_active__3zcZi"};